// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --nav-bar-width: 300px;
}

.navigation-controller {
    display: inline-block;
    width: 100%;
    height: 100%;
}
.navigation-controller__navbar {
    position: fixed;
    left: 0;
    top: var(--header-height);
    width: var(--nav-bar-width);
    height: 100%;
    display: inline-block;
    border: 1px solid #EEE;
    box-sizing: border-box;
    background-color: white;
    z-index: 10;
}

.navigation-controller__content {
    display: inline-block;
    margin-left: var(--nav-bar-width);
    min-width: calc(100% - var(--nav-bar-width));
    padding: 10px;
    box-sizing: border-box;
    text-align: left;
    background-color: #EEE;
}


@media (max-width: 1000px) {
    :root {
        --nav-bar-width: 200px;
    }
}
@media (max-width: 880px) {
    :root {
        --nav-bar-width: 170px;
    }
}

.navigation_controller__navigation_item {
    display: block;
    padding: 10px;
    text-decoration: none;
    color: black;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
}
.navigation_controller__navigation_item:hover, .navigation_controller__navigation_item.active {
    background-color: #f0f0f0;
}`, "",{"version":3,"sources":["webpack://./src/NavigationController/NavigationController.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,OAAO;IACP,yBAAyB;IACzB,2BAA2B;IAC3B,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iCAAiC;IACjC,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;AAC1B;;;AAGA;IACI;QACI,sBAAsB;IAC1B;AACJ;AACA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B","sourcesContent":[":root {\n    --nav-bar-width: 300px;\n}\n\n.navigation-controller {\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n}\n.navigation-controller__navbar {\n    position: fixed;\n    left: 0;\n    top: var(--header-height);\n    width: var(--nav-bar-width);\n    height: 100%;\n    display: inline-block;\n    border: 1px solid #EEE;\n    box-sizing: border-box;\n    background-color: white;\n    z-index: 10;\n}\n\n.navigation-controller__content {\n    display: inline-block;\n    margin-left: var(--nav-bar-width);\n    min-width: calc(100% - var(--nav-bar-width));\n    padding: 10px;\n    box-sizing: border-box;\n    text-align: left;\n    background-color: #EEE;\n}\n\n\n@media (max-width: 1000px) {\n    :root {\n        --nav-bar-width: 200px;\n    }\n}\n@media (max-width: 880px) {\n    :root {\n        --nav-bar-width: 170px;\n    }\n}\n\n.navigation_controller__navigation_item {\n    display: block;\n    padding: 10px;\n    text-decoration: none;\n    color: black;\n    border-bottom: 1px solid #ccc;\n    cursor: pointer;\n}\n.navigation_controller__navigation_item:hover, .navigation_controller__navigation_item.active {\n    background-color: #f0f0f0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
